import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import styles from './index.module.scss'
import { Container } from 'react-bootstrap';

const Faqs = (props) => {
  const {compData} = props;

  return (
    <div className={styles.wrapper}>
      <Container>
        <h2 className={styles.heading}>Frequently Asked Questions</h2>
      <div>
      <Accordion>
      {compData.map((item, key) => (
            <Accordion.Item eventKey={key} key={key}>
                <Accordion.Header>{item?.title?.rendered}</Accordion.Header>        
                <Accordion.Body>
                    <div dangerouslySetInnerHTML={{ __html: item?.content?.rendered }} />
                </Accordion.Body>
            </Accordion.Item>
        ))}
      </Accordion>
      </div>
      </Container>
    </div>
  );
};

export default Faqs;
